import React from 'react'
import InputNumber from '../input/input-number/InputNumber'

interface IFormTextEditorProps {
  name: string
  field: {name: string; value: any; onChange: () => void}
  form: {
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void
  }
  className: string
  maxLength?: number
  disabled?: boolean
  pattern?: RegExp
  handleChange?:(e: any)=>void
  handleBlur?:(e:any)=> void
}

export const FormInputNumber: React.FC<IFormTextEditorProps> = (props) => {
  return (
    <>
      <InputNumber
        maxLength={props.maxLength}
        className={props.className}
        name={props.field.name}
        value={props.field.value}
        disabled={props.disabled}
        pattern={props.pattern}
        handleChange={(e: any) => {
          e && props.form.setFieldValue(props.field.name, e.target.value)
          props.handleChange?.(e)
        }}
        handleBlur={(e:any)=> props.handleBlur?.(e)}
      />
    </>
  )
}
